import { useContext } from "react";
import { ColorProvider } from "~components/common/Layout";

export const WaterFree = () => {
  const { color, productBackground } = useContext(ColorProvider);
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="99" height="99" rx="49.5" fill="white" />
      <rect x="0.5" y="0.5" width="99" height="99" rx="49.5" stroke="#E2DFDF" />
      <circle
        cx="60.5059"
        cy="26.1172"
        r="15.9023"
        fill={productBackground || color}
      />
      <path
        d="M15.0167 54.5455H84.9833"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50.0005 60.3025V79.9142"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M56.2274 73.6359L50.7163 79.2688C50.3241 79.6696 49.679 79.6696 49.2867 79.2688L43.7757 73.6359"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M50.4518 20.2192C50.2977 20.0252 50.0427 19.9525 49.8115 20.0313C49.6643 20.0846 49.5476 20.1924 49.4825 20.3296C49.4499 20.3984 49.4268 20.4713 49.3869 20.5362C49.1932 20.8517 48.6691 21.5823 48.1216 22.3464C45.2696 26.322 39.9509 33.7158 39.9509 37.9521C39.9509 43.6186 44.4573 48.2246 50.0012 48.2246C55.5452 48.2246 60.0515 43.6186 60.0515 37.9521C60.0515 32.2855 50.8491 20.7161 50.4518 20.2192Z"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.9336 60.303V79.9147"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.1581 73.6364L27.6471 79.2692C27.2548 79.6701 26.6097 79.6701 26.2175 79.2692L20.7064 73.6364"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.2295 29.8446C27.1287 29.7174 26.9627 29.6689 26.8085 29.7234C26.7269 29.7526 26.6593 29.8106 26.6154 29.8834C26.5757 29.9493 26.5538 30.0248 26.5125 30.0897C26.3713 30.3119 26.0439 30.7654 25.6998 31.2446C23.8261 33.8506 20.3396 38.705 20.3396 41.4868C20.3396 45.2079 23.2984 48.2321 26.9331 48.2321C30.5678 48.2321 33.5325 45.2079 33.5325 41.4868C33.5325 37.7657 27.4845 30.1719 27.2295 29.8446Z"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.0646 60.303V79.9147"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M79.2915 73.6364L73.7805 79.2692C73.3882 79.6701 72.7431 79.6701 72.3509 79.2692L66.8398 73.6364"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M73.3588 29.8446C73.258 29.7174 73.092 29.6689 72.9378 29.7234C72.8562 29.7526 72.7886 29.8106 72.7447 29.8834C72.705 29.9493 72.6831 30.0248 72.6418 30.0897C72.5006 30.3119 72.1732 30.7654 71.829 31.2446C69.9553 33.8506 66.4689 38.705 66.4689 41.4868C66.4689 45.2079 69.4276 48.2321 73.0623 48.2321C76.697 48.2321 79.6617 45.2079 79.6617 41.4868C79.6617 37.7657 73.6138 30.1719 73.3588 29.8446Z"
        stroke="#1D1D1B"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
